"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = ['div[_ngcontent-%COMP%]{position:fixed;top:0;left:0;display:block;height:100%;width:100%;background-color:#fff;opacity:.1;z-index:99998}'];
